import { render, staticRenderFns } from "./PageMouvementsStock.vue?vue&type=template&id=7a5880dc&"
import script from "./PageMouvementsStock.vue?vue&type=script&lang=js&"
export * from "./PageMouvementsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5880dc')) {
      api.createRecord('7a5880dc', component.options)
    } else {
      api.reload('7a5880dc', component.options)
    }
    module.hot.accept("./PageMouvementsStock.vue?vue&type=template&id=7a5880dc&", function () {
      api.rerender('7a5880dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Stocks/PageMouvementsStock.vue"
export default component.exports